"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.DAYS_OF_THE_WEEK = exports.COLORS = void 0;
var TRANSLATION = {
  depart: 'Depart',
  return: 'Return',
  nextFlight: 'Next Flight',
  flight: 'flight',
  title: 'Baggage Allowance',
  content: 'The price you’re paying includes the following for each person',
  perGuest: 'per guest',
  Sunday: 'Sunday',
  Saturday: 'Saturday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday'
};
exports.TRANSLATION = TRANSLATION;
var COLORS = {
  GREY_DARKER: 'greyDarker',
  DEFAULT: 'default',
  PRIMARY: 'primary',
  PRIMARY_DARK: 'primaryDark',
  GREY_LIGHTER: 'greyLighter'
};
exports.COLORS = COLORS;
var DAYS_OF_THE_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
exports.DAYS_OF_THE_WEEK = DAYS_OF_THE_WEEK;